import { useEffect } from 'react';
import {
  clearRefreshTimer,
  ensureFreshSession,
  scheduleAccessTokenRefresh,
} from '@/utils/authSession';
import { useAppSelector } from '@/store/hooks';

export function useAuthSession(): void {
  const accessToken = useAppSelector((state) => state.auth.accessToken);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated || !accessToken) {
      clearRefreshTimer();
      return;
    }

    scheduleAccessTokenRefresh(accessToken);

    return () => {
      clearRefreshTimer();
    };
  }, [accessToken, isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) return;

    const handleResume = () => {
      if (document.visibilityState !== 'visible') return;
      void ensureFreshSession();
    };

    window.addEventListener('focus', handleResume);
    document.addEventListener('visibilitychange', handleResume);

    return () => {
      window.removeEventListener('focus', handleResume);
      document.removeEventListener('visibilitychange', handleResume);
    };
  }, [isAuthenticated]);
}
